// extracted by mini-css-extract-plugin
module.exports = {"cards":"JoinVivekaWrapper_cards__xj6C8","space":"JoinVivekaWrapper_space__Yk0cB"};